/**
 * Banner
 *
 * @param element
 * @param options
 * @constructor
 */
function Banner(element, options) {
    this.options = {
        placeAlias : null,
        url        : null,
        mode       : 'slide',
        slideMode  : 'vertical',
        timeoutSec : 2,
        debug      : false,
    };

    this.element = element;
    this.images = null;
    this.width = 0;
    this.height = 0;
    this.viewport = 0;
    this.rotator = null;
    this.currentImage = 0;
    this.resizing = null;

    this.init(options);
}

/**
 * Banner prototype
 */
Banner.prototype = {
    /**
     * Initializes the banner
     *
     * @param options
     */
    init: function (options) {
        if (options !== undefined && options !== null) {
            this.options = $.extend(this.options, options);
        }

        if (this.element === null || this.options.url === null || this.options.placeAlias === null) {
            console.error('Element, url and placeAlias is required for Banner!');

            return;
        }

        this.addEvents();
        this.load();
    },

    /**
     * Loads the images for the banner
     */
    load: function () {
        let _this = this;
        _this.calculateViewport();

        $.ajax({
            method: 'post',
            dataType: 'json',
            url: this.options.url,
            data: {
                placeAlias: this.options.placeAlias,
                viewport: this.viewport,
                url: window.location.href,
            },
        }).done(function (data) {
            if ('error' in data) {
                _this.element.html(data.error);
                _this.removeRotate();
            } else {
                _this.images = data.images;
                _this.width = data.width;
                _this.height = data.height;
                _this.render();
                _this.rotate();
            }

            if (_this.options.debug) {
                console.log(data);
            }
        });
    },

    /**
     * Renders the banners
     */
    render: function () {
        let images = this.images;
        let html = '<div class="banner-inner" style="min-height: 100%;">';
        let hasImage = false;

        this.calculateDimensions();
        let width = this.width;
        let height = this.height;

        // set element dimensions and settings
        this.element.css('width', width + 'px');
        this.element.css('height', height + 'px');
        this.element.css('max-width', '100%');
        this.element.css('position', 'relative');

        if (this.options.mode === 'slide' && images.length > 1) {
            if (this.options.slideMode === 'vertical') {
                this.element.css('overflow-y', 'hidden');
            } else {
                this.element.css('overflow-x', 'hidden');
            }
        }

        // add images to element
        for (let i = 0; i < images.length; i++) {
            hasImage = true;

            let position = this.calculatePosition(i);
            let target =  images[i].type === 'local' ? '_self' : '_blank';
            let href = images[i].url === null ? '' : 'href="' + images[i].url + '" target="' + target + '" ';

            html += '<a ' + href + 'style="display: block; overflow: hidden; position: absolute; top:'
                + position['top'] + '; left:' + position['left'] + '; width:100%;">'
                + '<img src="' + images[i].imgUrl + '" alt="' + images[i].description
                + '" style="width: 100%; height: auto;">'
                + '</a>';
        }

        if ( hasImage ) {
            this.element.addClass('has-image');
        } else {
            this.element.removeClass('has-image');
        }

        html += '</div>';

        this.element.html(html);
    },

    /**
     * Rotates the banners
     */
    rotate: function () {
        let _this = this;
        let elementInner = _this.element.find('div').first();

        // remove old rotator if exists
        _this.removeRotate();

        // if number of images is 0 or 1 don't have to rotate
        if (_this.images.length < 2) {
            return;
        }

        // disable all image if fade mode
        if (_this.options.mode === 'fade') {
            elementInner.find('a').each(function (i) {
                if (i !== _this.currentImage) {
                    $(this).css('opacity', 0);
                    $(this).css('z-index', 0);
                }

                // add transition to a
                $(this).css('transition', 'opacity 1s ease-in-out');
            });
        }

        _this.rotator = setInterval(function () {
            let nextID = (_this.currentImage === (_this.images.length - 1)) ? 0 : (_this.currentImage + 1);

            switch (_this.options.mode) {
                case 'fade':
                    // fade mode
                    let currentImage = elementInner.find('a:nth-child(' + (_this.currentImage + 1) + ')');
                    let nextImage = elementInner.find('a:nth-child(' + (nextID + 1) + ')');
                    _this.currentImage = nextID;

                    currentImage.css('opacity', 0);
                    currentImage.css('z-index', 0);
                    nextImage.css('opacity', 1);
                    nextImage.css('z-index', 1);

                    break;
                default:
                    // slide mode
                    let slideMode = _this.options.slideMode;
                    let translateMode = slideMode === 'vertical' ? 'translateY' : 'translateX';
                    let translateSize = slideMode === 'vertical' ? _this.height : _this.width;

                    // add transition to element inner
                    elementInner.css('transition', 'transform .5s ease-in-out');

                    // transform element inner
                    elementInner.css('transform', translateMode + '(-' + (nextID * translateSize) + 'px)');
                    _this.currentImage = nextID;
            }

        }, _this.options.timeoutSec * 1000);
    },

    /**
     * Removes rotator if exists
     */
    removeRotate: function () {
        if (this.rotator !== null) {
            clearInterval(this.rotator);
            this.rotator = null;
        }
    },

    /**
     * Calculates image position
     *
     * @param index
     * @returns {Array}
     */
    calculatePosition: function (index) {
        let position = [];

        switch (this.options.mode) {
            case 'fade':
                position['top'] = '0px';
                position['left'] = '0px';
                break;
            default:
                let slideMode = this.options.slideMode;
                position['top'] = slideMode === 'vertical' ? (index * this.height) + 'px' : '0px';
                position['left'] = slideMode === 'vertical' ? '0px' : (index * this.width) + 'px';
        }

        return position;
    },

    /**
     * Calculates the current max width and height
     */
    calculateDimensions: function () {
        let ratio = this.viewport / this.width;
        this.width = this.viewport;
        this.height = Math.round(this.height * ratio);
    },

    /**
     * Calculates the current viewport for the banner
     */
    calculateViewport: function () {
        let parent = this.element.parent();
        this.viewport = parent.width();
    },

    /**
     * Adds events
     */
    addEvents: function() {
        let _this = this;

        $(window).on('resize', $.debounce(1000, function() {

            if (_this.resizing) {
                clearTimeout(_this.resizing);
            }

            _this.resizing = setTimeout(function () {
                _this.removeRotate();
                _this.load();
                clearTimeout(_this.resizing);
                _this.resizing = null;
            }, 1000);
        }));
    },
};

/**
 * Init
 */

$(function () {
    $('.banner').each(function () {
        let options = $(this).data('bannerOptions');
        new Banner($(this), options);
    });
});



//////////////////
// WEBPACK FOOTER
// ./js/modules/banner.js
// module id = 11
// module chunks = 0 1 2 3 4